// MainImageHeaderItem
import React from 'react';
import { opacityAnimation } from './Animation/Animation';
import { motion } from 'framer-motion';
import PS from '../assets/PS.mp4';
import OrderCatalogButton from './button/OrderCatalogButton';

const heroFeatures = [
    {
        title: "3D-сборщик сцен",
        text: "Создавайте сцены с памятниками, оградами и элементами благоустройства прямо на сайте.",
        badge: "Подписка / оплата товара"
    },
    {
        title: "3D-дизайн под заказ",
        text: "Разрабатываем визуализации, сцены и модели под реальные проекты, размеры и задачи клиента.",
        badge: "Дизайн"
    },
    {
        title: "Собственное производство",
        text: "Изготавливаем памятники, металлические ограды, ритуальные изделия и МАФы для городской среды.",
        badge: "Производство"
    }
];

const MainImageHeaderItem = ({
    item,
    handleClick,
    type
}) => {
    const handleCatalogClick = () => {
        window.location.href = "/productsCategory/all";
    };

    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="mainImageHeaderContainer"
        >
            <video
                className="mainImageHeaderContainer__video"
                src={PS}
                autoPlay
                loop
                muted
                playsInline
            />

            <div className="mainImageHeaderContainer__shade" />

            <div className="mainImageHeader">
                <div className="mainImageHeader__inner">
                    <motion.div
                        custom={1}
                        variants={opacityAnimation}
                        className="mainImageHeader__headerTitle"
                    >
                        {item.header}
                    </motion.div>

                    <div className="mainImageHeader__grid">
                        <div className="mainImageHeader__main">
                            <motion.h1
                                custom={2}
                                variants={opacityAnimation}
                                className="mainImageHeader__title"
                            >
                                {item.name}
                            </motion.h1>

                            <div className="mainImageHeader__contentBlock">
                                <motion.h3
                                    custom={3}
                                    variants={opacityAnimation}
                                    className="mainImageHeader__description"
                                >
                                    {item.description}
                                </motion.h3>

                                <motion.p
                                    custom={4}
                                    variants={opacityAnimation}
                                    className="mainImageHeader__text"
                                >
                                    {item.descriptionButton}
                                </motion.p>

                                <div className="mainImageHeader__button">
                                    <OrderCatalogButton
                                        whiteBackground
                                        text={item.buttonText}
                                        onClick={type === "other" ? handleClick : handleCatalogClick}
                                    />
                                </div>
                            </div>
                        </div>

                        <motion.div
                            custom={5}
                            variants={opacityAnimation}
                            className="mainImageHeader__features"
                        >
                            <div className="mainImageHeader__featuresHeader">
                                <span>ALOTB 3D</span>
                                <p>Цифровой подбор, дизайн и производство</p>
                            </div>

                            <div className="mainImageHeader__featureList">
                                {heroFeatures.map((feature, index) => (
                                    <div
                                        className="mainImageHeader__feature"
                                        key={index}
                                    >
                                        <div className="mainImageHeader__featureTop">
                                            <span className="mainImageHeader__featureNumber">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>

                                            <span className="mainImageHeader__featureBadge">
                                                {feature.badge}
                                            </span>
                                        </div>

                                        <h4>{feature.title}</h4>
                                        <p>{feature.text}</p>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default MainImageHeaderItem;